// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1S60j","subheader":"ReorderModal_subheader__1MJcc","listWrap":"ReorderModal_listWrap__2P3gO"};